import React from "react";
import { MovingWebsite } from "../../components/UnderConstruction";
import { InstaEmbedRow } from "../../components/Embeds/components/embeds/EmbedRow";

export function artcomics() {
return ( 
 <>
<div className="row">
<div className="col"><MovingWebsite/>
</div>
</div>
<InstaEmbedRow
    url1="https://www.instagram.com/p/ChM_WhMKv_K"
    url2="https://www.instagram.com/p/"
    url3="https://www.instagram.com/p/"
/>
</>
);
}

/* 
<InstaEmbedRow
    url1="https://www.instagram.com/p/"
    url2="https://www.instagram.com/p/"
    url3="https://www.instagram.com/p/"
/>
 */